// Hooks / Node modules / Styles
import { Button } from "elseware-ui";
import { motion } from "framer-motion";

// Reducers / Actions

// Utils / Functions

// Components

// Sub-Components

// Data / Images / Icons
import { me } from "src/assets";
// import cv_pro from "src/assets/pdfs/DhanushkaSandakelum_Professional_CV.pdf";
// import cv_academic from "src/assets/pdfs/DhanushkaSandakelum_Academic_CV.pdf";

const Throbber = () => {
  return (
    <div className="w-full flex justify-center items-center mt-auto mb-8">
      <a href="#about">
        <div className="w-[35px] h-[64px] rounded-3xl border-4 border-dark-100 dark:border-light-800 flex justify-center items-start p-2">
          <motion.div
            animate={{
              y: [0, 24, 0],
            }}
            transition={{
              duration: 1.5,
              repeat: Infinity,
              repeatType: "loop",
            }}
            className="w-3 h-3 rounded-full bg-dark-100 dark:bg-light-800 mb-1"
          />
        </div>
      </a>
    </div>
  );
};

function Hero() {
  // const downloadPDFPro = () => {
  //   const a = document.createElement("a");
  //   a.href = cv_pro;
  //   a.download = "DhanushkaSandakelum_Professional_CV.pdf";
  //   a.click();
  // };

  // const downloadPDFAcademic = () => {
  //   const a = document.createElement("a");
  //   a.href = cv_academic;
  //   a.download = "DhanushkaSandakelum_Academic_CV.pdf";
  //   a.click();
  // };

  return (
    <div className="h-[90vh] flex flex-col items-center justify-between">
      <section className="hero text-center flex-grow">
        {/* Image Section */}
        <div className="mb-6">
          <img
            src={me}
            alt="Dhanushka Sandakelum"
            className="w-52 h-52 rounded-full mx-auto mb-4"
          />
        </div>

        {/* Text Section */}
        <h1 className="text-4xl font-bold local-theme-text-md">
          Hi, I'm Dhanushka Sandakelum
        </h1>
        <p className="text-lg mb-4 local-theme-text-sm">
          Software Engineer | Game Developer
        </p>
        <p className="mb-6 local-theme-text-xs">
          I create innovative solutions for web, software, and game development.
        </p>

        {/* Button Section */}
        {/* <div className="flex justify-center gap-4">
          <Button
            variant="success"
            text="Download CV (Professional)"
            shape="softRoundedSquare"
            onClick={downloadPDFPro}
          />

          <Button
            variant="success"
            ghost
            text="Download CV (Academic)"
            shape="softRoundedSquare"
            onClick={downloadPDFAcademic}
          />
        </div> */}
        
      </section>

      <Throbber />
    </div>
  );
}

export default Hero;
